import type { PermissionGroup } from './models/UserInterfaces';

interface UserPermissionProps {
    id: number;
    userPermissions: PermissionGroup[];
    update(groupId: number, id: number, selected: boolean): void;
    save(): void;
}

const UserPermissionData = (props: UserPermissionProps) => {
    return (
        <div>
            <div className="row">
                {props.userPermissions.map(permissionGroup =>
                    <div key={permissionGroup.groupId}>
                        <div className="makeitbold text--large">{permissionGroup.group}</div>
                        {permissionGroup.permissions.map(permission => 
                            <label key={permission.id} className="input-group marginLeft30">
                                <input type='checkbox' className="input-control user__checkboxPosition marginRight10" checked={permission.selected} onChange={(e) => props.update(permissionGroup.groupId, permission.id, e.target.checked)} />
                                <span className="label-unlimited user__checkboxLabelPosition">{permission.name}</span>
                            </label>
                        )}
                    </div>
                )}
            </div>

            <div className="row">
                <button className="defaultbutton defaultbutton-next" type="button" onClick={props.save}>Save</button>
            </div>
        </div>
    );

}

export default UserPermissionData;